<template>
  <div>
    <v-toolbar flat style="margin-left: -10px;padding: 0 85px 0 0;background-color:transparent">
      <v-toolbar-title><h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px"><v-icon style="font-size: 20px;">mdi-instagram</v-icon> &nbsp;&nbsp;&nbsp;&nbsp;{{ $t('menuType.instagram') }}&nbsp;&nbsp;&nbsp;&nbsp;</h5></v-toolbar-title>
      <!-- <v-divider vertical  style="margin: 0 10px 0 10px;"/> -->
      <!-- <span style="color:rgba(0, 0, 0, 0.54);">{{$t('instagram.instagramIframe')}}</span> -->
      <!-- <v-text-field
        v-model="instagramIframe"
        append-icon="mdi-search"
        hideDetails
        single-line
        style="margin-left: 15px;"
        @input="handleSetInstagramIframe"
      /> -->
    </v-toolbar>
    <div style="padding: 0 10px 10px 10px;">
      
      <v-textarea
        v-show="!collapseContent"
        v-model="instagramIframe"
        append-icon="mdi-search"
        :label="$t('instagram.instagramIframe')"
        hideDetails
        @input="handleSetInstagramIframe"
      />
    </div>
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import _ from 'lodash'
  export default {
    props: {
      content: {
        type: Object,
        required: true
      },
    },
    data: () => ({
      instagramIframe: ''
    }),
    computed: {
      ...mapState('app',['collapseContent']),
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
    },
    created () {
      this.handleSetInstagramIframe = _.debounce(() => {
        this.onSetInstagramIframet(this.instagramIframe)
      }, 500)
    },
    mounted() {
      this.instagramIframe = this.content.InstagramIframe
    },
    methods: {
      onSetInstagramIframet() {
        this.content.InstagramIframe = ''
        const that = this
        setTimeout(function(){
            that.content.InstagramIframe = that.instagramIframe
        }, 500);
        
        this.handleChangeIsModified
      },
      handleChangeIsModified () {
        this.$store.state.app.isModified = false
      }
    }
  }
</script>

<style scoped>
</style>

